import { createFileRoute } from "@tanstack/react-router";
import { DCEL, type Polygon } from "geom/polyclip/dcel";
import { dcelFromPolygonsSnapRound } from "geom/polyclip/dcelFromPolygons";
import { renderDCEL, renderDCELEdges, renderDCELVerts } from "geom/polyclip/render";
import { useCallback } from "react";
import Canvas from "./-Canvas";

function SnapRoundTest() {
  const func = useCallback((canvas: HTMLCanvasElement, context: CanvasRenderingContext2D, viewerScale: number) => {
    const rect: Polygon = [
      [
        [10, 0],
        [80, 0],
        [80, 80],
        [0, 80],
        [10, 0],
      ],
    ];

    const rectShifted: Polygon = [
      [
        [0, 0],
        [80, 0],
        [80, 80],
        [0, 80],
        [0, 0],
      ],
    ];

    rectShifted.forEach((loop) =>
      loop.forEach((v) => {
        v[0] = v[0] + 30;
        v[1] = v[1] + 30;
      }),
    );

    const dcel = dcelFromPolygonsSnapRound({ polygons: [rect, rectShifted], snapRoundPrecision: 1 });

    context.clearRect(0, 0, canvas.width, canvas.height);

    context.save();

    context.scale(4, -4);
    context.translate(20, -130);

    // draw vertical and horizontal lines in grey

    context.strokeStyle = "#ccc";
    context.lineWidth = 0.1;
    context.beginPath();

    for (let x = -500; x < 500; x += 1) {
      context.moveTo(x, -500);
      context.lineTo(x, 500);
    }

    for (let y = -500; y < 500; y += 1) {
      context.moveTo(-500, y);
      context.lineTo(500, y);
    }

    context.stroke();

    const dcelScaled = new DCEL(
      dcel.vertices,
      dcel.halfEdges,
      dcel.vertexHalfEdges,
      dcel.halfEdgeVertexIndices,
      dcel.faceHalfEdges,
      dcel.faceSignedAreas,
      dcel.halfEdgeToFace,
      dcel.halfEdgeToPolygon,
      dcel.faceToPolygons,
      dcel.faceToParentFace,
      dcel.faceToChildFaces,
      dcel.segmentToPolygon,
      dcel.segmentToPolygonLoop,
      dcel.segmentToPolygonLoopEdge,
      dcel.segmentToHalfEdges,
    );

    renderDCEL(context, dcelScaled);
    renderDCELEdges(context, dcelScaled, 3, 0.25, 1 / viewerScale);
    renderDCELVerts(context, dcelScaled, 1 / viewerScale);

    context.restore();
  }, []);

  return <Canvas canvasWidth={700} canvasHeight={700} render={func} />;
}

export const Route = createFileRoute("/debug/polyclip/snap-round-test")({
  component: SnapRoundTest,
});
